"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmphasizeText = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const EmphasizeText = ({
  content,
  startWith
}) => {
  const found = startWith.find(text => content.includes(text));
  if (!found) {
    // eslint-disable-next-line react/jsx-no-useless-fragment -- a way to return jsx
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: content
    });
  }
  const contentArray = content.split(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: contentArray.map((word, index) => {
      const key = `${word}${index}`;
      const isEmphasized = startWith.some(letter => word.startsWith(letter));
      return isEmphasized ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("strong", {
        children: [word, " "]
      }, key) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [word, " "]
      }, key);
    })
  });
};
exports.EmphasizeText = EmphasizeText;
